import React, { useState } from 'react';
import { useLocation } from 'react-router-dom'; // Import useLocation to access the token
import { useNavigate } from 'react-router-dom'; 
import '../styles/UserTypeSelection.css';
import indSeeker from '../assets/indseeker.jpg';
import indProvider from '../assets/indprovider.jpg';
import agencySeeker from '../assets/agencyseeker.jpg';
import agencyProvider from '../assets/agencyprovider.jpg';

const UserTypeSelection = () => {
  const location = useLocation(); // Get the token from location.state
  const { token , FullName } = location.state || {};
  const navigate = useNavigate(); 
  const [selectedRole, setSelectedRole] = useState(null);

  const roles = [
    {
      id: 'individual_provider',
      title: 'Individual Provider',
      description: 'A person who posts job opportunities for temporary medical staffing to meet personal healthcare needs.',
      image: indProvider,
    },
    {
      id: 'agency_provider',
      title: 'Agency Provider',
      description: 'An organization that posts job opportunities for temporary medical staffing to meet organizational requirements.',
      image: agencyProvider,
    },
    {
      id: 'individual_applicant',
      title: 'Individual Applicant',
      description: 'A medical professional who applies for temporary job opportunities based on their qualifications.',
      image: indSeeker,
    },
    {
      id: 'agency_applicant',
      title: 'Agency Applicant',
      description: 'A medical team or organization that seeks temporary job placements for providing specialized medical services.',
      image: agencySeeker,
    },
  ];

  const handleRoleSelect = (id) => {
    setSelectedRole(id); // Save the selected role
  };

  const handleNextClick = () => {
    if (selectedRole === 'individual_provider' || selectedRole === 'agency_provider') {
      navigate('/user-redirection', { state: { token , FullName , selectedRole} }); // Navigate to HomePage.js
    } else if (selectedRole === 'individual_applicant' || selectedRole === 'agency_applicant') {
      navigate('/user-redirection', { state: { token , FullName , selectedRole} }); // Navigate to HomePage.js
    } else {
      alert('Please select a role to proceed.');
    }
  };

  return (
    <div className="user-type-selection">
      <h2>Select Your Role</h2>
      <p>To proceed, please select the user type that best describes your role.</p>
      <div className="roles-container">
        {roles.map((role) => (
          <div
            key={role.id}
            className={`role-card ${selectedRole === role.id ? 'selected' : ''}`}
            onClick={() => handleRoleSelect(role.id)}
          >
            <img src={role.image} alt={role.title} className="role-image" />
            <h3>{role.title}</h3>
            <p>{role.description}</p>
          </div>
        ))}
      </div>
      <button className="next-button" onClick={handleNextClick}>
      Next
      </button>
    </div>
  );
};

export default UserTypeSelection;
